import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Rilevazione, StatoPrenotazione } from 'src/app/models/rilevazione-presenze/rilevazione';
import { UtilityService } from 'src/app/services/utility.service';
import { DidatticaService } from 'src/app/services/didattica-service';
import { ConfigService } from 'src/app/services/config-service/config-service';
import { ChiaveConfig } from 'src/app/models/configurazioni/ChiaveConfig';
import { Studente } from 'src/app/models/didattica/studente';
import { TranslateService } from '@ngx-translate/core';
import { RilevazionePresenzeService } from 'src/app/services/rilevazione-presenze-service';

@Component({
    selector: 'app-radar-ril-viewer',
    templateUrl: './radar-ril-viewer.component.html',
    styleUrls: ['./radar-ril-viewer.component.scss'],
    standalone: false
})
export class RadarRilViewerComponent implements OnInit {
  @Input() ril: Rilevazione;
  @Input() stud: Studente;
  @Output() rilSelected = new EventEmitter();
  @Input() acknowledged = false;


  now = Date.now().valueOf() ;
  radardistance: number;
  radaraccuracy: number;
  motivoMarcaturaNonDisponibile: string;
  
  moderoglezione = '';

  constructor(
    private utilityService: UtilityService,
    private didatticaService: DidatticaService,
    private translateService: TranslateService,
    private rilevazionePresenzeService: RilevazionePresenzeService,
    public configService: ConfigService
    ) {
     }

  ngOnInit() {
    console.log('ngOnInit');
    this.ril.ar = this.didatticaService.parseResponse( [this.ril.ar] )[0];
    this.radardistance = this.configService.getConfigurazione(ChiaveConfig.RADAR_RIL_DISTANCE);
    this.radaraccuracy = this.configService.getConfigurazione(ChiaveConfig.RADAR_RIL_DISTANCE_ACCURACY);
    if (this.configService.indicaErogazioneFruizione) { 
      this.moderoglezione = this.rilevazionePresenzeService.decodeModalita(this.ril.modalitaErogazione);
      if (this.moderoglezione === 'i') {
        this.moderoglezione = undefined;
      }
    } else {
      this.moderoglezione = 'p'; 
    }
    this.marcaturaDisponibile();
  }


  switchRadio(event: any) {
    this.moderoglezione = event;
    console.log('this.moderoglezione', this.moderoglezione);
  }

  activeSince(istanteCreazione) {
    let elapsed = 0;
    if (istanteCreazione) {
      elapsed = (this.now - new Date(istanteCreazione).valueOf()) / 1000 ;
    }
    return this.utilityService.formatDate(elapsed);
  }

  marca(rilevazione: Rilevazione) {
    // console.log('emit ril', ril);
    // this.rilSelected.emit(rilevazione);
    const data = {
      rilevazione: rilevazione,
      assenza: false,
      moderoglezione: this.moderoglezione
    };
    this.rilSelected.emit(data);
  }

  segnalaAssenza(rilevazione: Rilevazione) {
    // console.log('emit ril', ril);
    const data = {
      rilevazione: rilevazione,
      assenza: true
    };
    this.rilSelected.emit(data);
  }


  marcaturaDisponibile() {
    // nel caso in cui sia prevista la prenotazione controlla
    // che lo studente possa marcare
    this.motivoMarcaturaNonDisponibile = null;
    if (this.ril.prenotazione === StatoPrenotazione.PREVISTA) {
      console.log('richiamata verifica prenotazione');
      const messageMarcaturaNonDisponibile =
          this.translateService.instant('avvio-marcatura.message.marcatura-non-disponibile');
          // 'La rilevazione prevede una prenotazione obbligatoria che non è stata recuperata'
      // this.prenotato = false;
      this.rilevazionePresenzeService
        .verificaPrenotazione(this.ril, this.stud)
          .subscribe(prenotato => {
            if (prenotato) {
              console.log('la prenotazione è presente');
            } else {
              console.log('la prenotazione NON è presente');
              // this.puoMarcare = false;
              this.motivoMarcaturaNonDisponibile = messageMarcaturaNonDisponibile;
            }
          }
        );
    }
  }
}
